import { useQuery } from 'react-query';
import queryGetRentalFiles from './queries/getRentalFiles';
import queryGetRentalFile from './queries/getRentalFile';

const actionsRentalFiles = {
    // Getters
    getRentalFiles: (query, enabled, remoteCollectionId) => useQuery(queryGetRentalFiles(query, enabled, remoteCollectionId)),
    getRentalFile: (rentalFileId, enabled = true) => useQuery(queryGetRentalFile(rentalFileId, enabled))
};

export default actionsRentalFiles;